module.exports = __webpack_public_path__ + "img/top-right.bed4700e.jpg";